import { Typography } from '@/components/Typography';
import { Button } from '@/components/ui/button';
import chat from '@/assets/images/icons/chat.svg';
import { useAlertDialog } from '@/shared/context/AlertDialogContext';
import { useAuth } from '@/shared/provider/AuthProvider';
import { useNavigate } from 'react-router-dom';

interface Props {
	starId?: number;
}

const FanChatButton = ({ starId }: Props) => {
	const { showAlert, closeAlert } = useAlertDialog();
	const { userInfo } = useAuth();
	const navigate = useNavigate();

	const handleRedirectApp = () => {
		const starIdStr = String(starId);

		window.location.href = `https://angkorlife.onelink.me/MIbi/?id=${userInfo?.token}&angkorChatInfo=${starIdStr}`;
	};

	const handleNavigate = () => {
		if (userInfo) {
			showAlert({
				logo: true,
				title: 'Experience AngkorLife in the app!',
				description:
					'Enjoy even more content and features when you use the app.',
				actionText: 'Continue in App',
				onConfirm: () => {
					handleRedirectApp();
					closeAlert();
				},
				hasSecondaryModal: true,
			});
		} else {
			showAlert({
				logo: false,
				title: 'Would you like to log in?',
				actionText: 'Log in',
				cancelText: 'Cancel',
				onConfirm: () => navigate('/login'),
				onCancel: () => closeAlert(),
			});
		}
	};

	return (
		<div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background-primary min-w-[360px] max-w-[768px] mx-auto">
			<Button className="w-full h-12" onClick={handleNavigate}>
				<Typography
					variant="h6"
					className="flex items-center justify-center gap-1">
					<img src={chat} alt="fan chat" />
					Fan chat
				</Typography>
			</Button>
		</div>
	);
};

export default FanChatButton;
